import { Injectable, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslationService } from './i18n/translation.service';

/**
 * Route titles are translation keys (pageTitle.*); the browser tab shows them in
 * the chosen language and follows a language change without a new navigation.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly appName = 'Morichal AI';
  private readonly translation = inject(TranslationService);
  private titleKey: string | undefined;

  constructor(private readonly title: Title) {
    super();
    effect(() => {
      this.translation.getCurrentLanguage()();
      this.apply();
    });
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    this.titleKey = this.buildTitle(routerState);
    this.apply();
  }

  private apply(): void {
    const title = this.titleKey ? this.translation.t(this.titleKey) : '';
    this.title.setTitle(title ? `${title} | ${this.appName}` : this.appName);
  }
}
